import { defineSwitchComponent } from "@tylertech/forge";
import { getLoggerFor } from "@tylertech/logging";
import { EVENT_BUS_TOKEN, SmartPulsePlugin } from "@tylertech/smart-pulse-core";
import { CHAT_SIDEBAR_SERVICE_TOKEN } from "@tylertech/smart-pulse-foundry-chat-sidebar";
import { Observable } from "rxjs";
import { FollowMeMode } from "./followMe";

export function createFollowMePlugin(liveModeChanged: Observable<boolean>, onReady?: (followMe: FollowMeMode) => void): SmartPulsePlugin
{
    return {
        id: "erp-follow-me",
        requiresPlugins: ["chat-sidebar-service"],
        requiresTokens: [EVENT_BUS_TOKEN, CHAT_SIDEBAR_SERVICE_TOKEN],
        init: (): void => { return; },
        afterInit: (container): void =>
        {
            const events = container.tryResolve(EVENT_BUS_TOKEN);
            const api = container.tryResolve(CHAT_SIDEBAR_SERVICE_TOKEN);
            const component = api?.getComponent();
            if (!events || !api || !component)
            {
                getLoggerFor("FollowMePlugin").warning("Follow me not started: event bus or chat sidebar unavailable",
                    { hasEvents: !!events, hasApi: !!api, hasComponent: !!component });
                return;
            }

            defineSwitchComponent();

            const followMe = new FollowMeMode(component, () => api.isOpen(), events);
            followMe.init();

            const followMeSwitch = document.createElement("forge-switch");
            followMeSwitch.slot = "header-actions";
            followMeSwitch.dense = true;
            followMeSwitch.checked = followMe.enabled;
            followMeSwitch.textContent = "Follow me";
            followMeSwitch.addEventListener("forge-switch-change", () => followMe.toggle());
            component.appendChild(followMeSwitch);

            liveModeChanged.subscribe(live =>
            {
                followMeSwitch.hidden = live;
                followMe.setPaused(live);
            });

            onReady?.(followMe);
        },
    };
}
